import { render, staticRenderFns } from "./CustomerPlus.vue?vue&type=template&id=afb5ca36&scoped=true&"
import script from "./CustomerPlus.vue?vue&type=script&lang=js&"
export * from "./CustomerPlus.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPlus.vue?vue&type=style&index=0&id=afb5ca36&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb5ca36",
  null
  
)

export default component.exports